import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, Select, TOAST_TYPE } from '@base'
import { MB_ROLES, strings } from '@constants'
import { getAllEmployees } from '@data'
import { updateAssignedFinanceAnalyst } from '@data/conn/put/cran'
import { User } from '@data/model'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'

const AssignFinanceAdmin = ({ assignedAnalyst, update }) => {
	const dispatch = useDispatch()
	const { orgId } = useParams()
	const [selectedUser, setSelectedUser] = useState()
	const [adminList, setAdminList] = useState([])
	const loggedInUser = useSelector((state) => state.getIn(['user', 'user']))

	useEffect(() => {
		setSelectedUser(assignedAnalyst)

		getAllEmployees({ roleFilter: MB_ROLES.FINANCE })
			.then((response) => {
				setAdminList(response.map((item) => new User(item).getUserDetails()))
			})
			.catch((error) => {
				console.log(error)
			})
			.finally(() => {})
	}, [assignedAnalyst])

	const onChangeHandler = (val) => {
		setSelectedUser(val)
	}

	const submitHandler = () => {
		dispatch(showLoader(true))
		updateAssignedFinanceAnalyst(orgId, loggedInUser?.user_id, selectedUser)
			.then((response) => {
				dispatch(showToast(true, strings('msg_finance_analyst_assigned_successfully'), { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((error) => {
				dispatch(showToast(true, strings('msg_finance_analyst_not_assigned'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				update()
				dispatch(toggleDrawer(false))
				dispatch(showLoader(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<Select
					id={'assigned-analyst-id'}
					label={strings('assigned_finance_analyst')}
					placeholder={strings('select', 'assigned_finance_analyst')}
					disabled={false}
					required={true}
					data={adminList ?? []}
					displayKey={'full_name'}
					primaryKey={'user_id'}
					value={adminList?.find((item) => item.user_id === selectedUser?.user_id) ?? {}}
					onChange={onChangeHandler}
				/>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small onClick={submitHandler}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AssignFinanceAdmin
